import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import ProfileGridOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('profile-grid', {
  template: require('./template.html'),
  name: 'profile-grid',
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentSite',
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
      'globalOpenModal',
      'bouncePluginHook',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    feed() {
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic.profiles;
      const feed = enabled ? _.cloneDeep(enabled.published || []) : [];
      _.forEach(feed, (item) => {
        item.image = this._servePrefix(item.image) + item.image;
      });
      return feed;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzProfile-grid' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        searchBrdrWidthTop: null,
        searchBrdrWidthBottom: null,
        searchBrdrWidthLeft: null,
        searchBrdrWidthRight: null,
        searchBrdrRadiusTopRight: null,
        searchBrdrRadiusTopLeft: null,
        searchBrdrRadiusBottomRight: null,
        searchBrdrRadiusBottomLeft: null,
        searchLetterSpacing: null,
        barRadiusTopRight: null,
        barRadiusTopLeft: null,
        barRadiusBottomRight: null,
        barRadiusBottomLeft: null,
        fbPaddingTop: null,
        fbPaddingBottom: null,
        fbPaddingLeft: null,
        fbPaddingRight: null,
        'box-shadow': null,
        'letter-spacing': null,
        'border-top-width': null,
        'border-bottom-width': null,
        'border-left-width': null,
        'border-right-width': null,
        'border-top-right-radius': null,
        'border-top-left-radius': null,
        'border-bottom-right-radius': null,
        'border-bottom-left-radius': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    ProfileGridOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
      this.bouncePlugin();
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzProfile-item-card',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    globalOpenModal(open) {
      if (!open) {
        // we trigger the rerender here if user is adding new dynamic data
        this.bouncePlugin();
      }
    },
    bouncePluginHook(id) {
      if (this.droplet._id === id) {
        this.bouncePlugin();
        this.$store.dispatch('callPluginBounce', false);
      }
    },
  },
  beforeDestroy() {
    this.destroyPlugin();
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    this.initPlugin();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
    destroyPlugin() {
      const $droplet = $(this.$refs.profileGrid);
      if ($droplet.drzFilterGrid.destroy) {
        $droplet.drzFilterGrid.destroy($droplet);
      }
    },
    initPlugin() {
      const $droplet = $(this.$refs.profileGrid);
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic.profiles;
      const categories = enabled ? enabled.categories : [];
      const customCategories = this.droplet.customCategories;
      let filters = false;
      if (!this.droplet.hideFilters && !this.droplet.customList && categories.length > 0) {
        filters = categories;
      }
      if (!this.droplet.hideFilters && this.droplet.customList && customCategories.length > 0) {
        filters = customCategories;
      }
      let feed = this.feed;
      if (this.droplet.customList) {
        feed = feed.filter(p => customCategories.some(f => p.categories.indexOf(f) >= 0));
      }
      const truncate = this.truncate;
      const reveal = this.showRevealClass ? ' drzAnimation-onReveal' : '';
      $droplet.drzFilterGrid({
        output(data) {
          let contact = '';
          if (data.phone || data.email || data.address || data.website) {
            const phone = data.phone ? `<span class="drzProfile-item-contactSpan">${data.phone}</span>` : '';
            const email = data.email ? `<span class="drzProfile-item-contactSpan">${data.email}</span>` : '';
            const website = data.website ? `<span class="drzProfile-item-contactSpan">${data.website}</span>` : '';
            const address = data.address && data.address.value ? `<span class="drzProfile-item-contactSpan">${data.address.value}</span>` : '';
            contact = `
            <div class="drzProfile-item-contact">
              ${email}${phone}${address}${website}
            </div>`;
          }
          const preview = data.description ? `<p class="drzProfile-item-preview">${truncate(data.descriptionPlainText || '', 500)}</p>` : '';
          return `
            <li class="drzProfile-item-card${reveal}">
              <a href="${data.pageLink || '#'}" class="drzProfile-item-link">
                <div class="drzProfile-item-imgWrap">
                  <img class="drzProfile-item-img" data-asset="${data.image}" alt="${data.name}" />
                </div>
                <div class="drzProfile-item-data">
                  <div class="drzProfile-item-top">
                    <h4 class="drzProfile-item-header">${data.name}</h4>
                  </div>
                  <hr class="drzProfile-item-break" />
                  ${contact}
                  ${preview}
                </div>
              </a>
            </li>
          `;
        },
        onRender($card) {
          const $link = $card.find('.drzProfile-item-link');
          $link.click(e => e.preventDefault());
        },
        feed,
        filters,
        match: 'all',
        pagination: this.droplet.paginate,
        sortKey: this.droplet.sortKey,
        sort: this.droplet.sort,
        filterText: this.droplet.filterText,
        gridContainer: 'drzProfile-items-container',
        map: this.droplet.map,
        searchKeys: ['name', 'description', 'address.value', 'phone', 'email', 'website'],
      });
    },
    bouncePlugin() {
      this.destroyPlugin();
      this.initPlugin();
    },
    truncate(text, limit) {
      if (text.length < limit) {
        return text;
      }
      return `${text.substring(0, limit)}...`;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/profile-grid/index.js